import { useSelector } from 'react-redux'

import TrafficObjectivePromotedObjectFields from './TrafficObjectivePromotedObjectFields'
import AppPromotionObjectivePromotedObjectFields from './AppPromotionObjectivePromotedObjectFields'
import StandardDatesetEventRadioBlock from './StandardDatesetEventRadioBlock'
import CustomConversionsRadioBlock from './CustomConversionsRadioBlock'
import LeadAdsFormRadioBlock from './LeadAdsFormRadioBlock'

import { useFetchPromotedObjectFieldsData } from '../../../../../../../../features/hooks/useFetchPromotedObjectFieldsData'

import { facebookRightUploadAdCampaignSelector } from '../../../../../../../../modules/selectors/rights'

import {
  COST_CAP,
  OUTCOME_APP_PROMOTION,
  OUTCOME_LEADS,
  OUTCOME_TRAFFIC
} from '../../../../../../../../constants/campaigns'
import { BIDDING_TYPE } from '../../../../../../CampaignForms/CampaignFacebookCreate/CampaignFacebookCreateForm/fields'
import { PROMOTED_PIXEL } from '../../../../../../../../constants/selectLists/customEventTypes/fields'

const PromotedObjectFields = ({ formik }) => {
  const campaign = useSelector(facebookRightUploadAdCampaignSelector)

  const isOutcomeTraffic = campaign.objective === OUTCOME_TRAFFIC
  const isOutcomeLeadsCampaign = campaign.objective === OUTCOME_LEADS
  const isOutcomeAppPromotion = campaign.objective === OUTCOME_APP_PROMOTION
  const showTargetCostCapField = campaign[BIDDING_TYPE] === COST_CAP

  const { values } = formik
  const { eventTypeOptions, formattedPixels } = useFetchPromotedObjectFieldsData(
    values[PROMOTED_PIXEL],
    campaign.objective
  )

  if (isOutcomeTraffic) {
    return (
      <TrafficObjectivePromotedObjectFields
        formik={formik}
        formattedPixels={formattedPixels}
        showTargetCostCapField={showTargetCostCapField}
      />
    )
  } else if (isOutcomeAppPromotion) {
    return <AppPromotionObjectivePromotedObjectFields formik={formik} showTargetCostCapField={showTargetCostCapField} />
  } else {
    return (
      <>
        <StandardDatesetEventRadioBlock
          formik={formik}
          formattedPixels={formattedPixels}
          eventTypeOptions={eventTypeOptions}
          showTargetCostCapField={showTargetCostCapField}
        />
        <CustomConversionsRadioBlock formik={formik} showTargetCostCapField={showTargetCostCapField} />
        {isOutcomeLeadsCampaign && <LeadAdsFormRadioBlock formik={formik} />}
      </>
    )
  }
}

export default PromotedObjectFields
